// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"S1-z","dimensionLabel":"T1-z","styleChooserControlWrapper":"U1-z","styleChooserControl":"V1-z","disabled":"W1-z","giftCard":"X1-z","styleChooserText":"Y1-z"};